import { Link } from "react-router-dom";
import { ArrowDown } from "lucide-react";
import { ClinqLogo } from "../ClinqLogo";
import { SaccoShareButton } from "./SaccoShare";

export const scrollToDemoForm = () => {
  document.getElementById("sacco-demo-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const SaccoHero = () => (
  <section className="relative overflow-hidden bg-[#0B2A28] text-white" data-testid="sacco-hero">
    <div className="pointer-events-none absolute -right-32 -top-32 h-[520px] w-[520px] rounded-full bg-[#0A8B85]/25 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-40 left-1/3 h-[420px] w-[420px] rounded-full bg-[#E3B84C]/10 blur-3xl" />
    <header className="relative mx-auto flex max-w-6xl items-center justify-between px-5 py-6">
      <Link to="/" data-testid="sacco-logo-link"><ClinqLogo size="lg" tone="white" /></Link>
      <div className="flex items-center gap-3">
      <span className="hidden rounded-full border border-[#E3B84C]/50 bg-[#E3B84C]/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-[#E3B84C] sm:inline-block">
        For SACCOs
      </span>
      <SaccoShareButton variant="dark" testid="sacco-hero-share-btn" />
      </div>
    </header>
    <div className="relative mx-auto max-w-6xl px-5 pb-20 pt-10 sm:pb-28 sm:pt-16">
      <h1 className="max-w-4xl text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-testid="sacco-hero-headline">
        SACCOs protect against loss.{" "}
        <span className="text-[#7BD3CE]">They rarely test for it in advance.</span>
      </h1>
      <div className="mt-7 max-w-2xl space-y-4 text-base leading-relaxed text-[#B9D9D6] md:text-lg" data-testid="sacco-hero-subheading">
        <p data-testid="sacco-hero-subheading-line-1">
          Right now, most SACCO loans are approved based on how much a member has saved — not whether they can
          actually afford to repay from their income.
        </p>
        <p data-testid="sacco-hero-subheading-line-2">
          When members can't repay, guarantors and other members end up carrying the loss. Clinq gives your credit
          team a repayment-capacity check on every application — in under an hour — without replacing your guarantor
          or collateral model.
        </p>
      </div>
      <button type="button" onClick={scrollToDemoForm}
        className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-[#E3B84C] px-7 py-4 text-sm font-extrabold text-[#0B2A28] shadow-[0_12px_30px_-10px_rgba(227,184,76,0.7)] transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-[#EFC65E]"
        data-testid="sacco-hero-cta">
        Book a demo for your SACCO today <ArrowDown size={16} />
      </button>
    </div>
  </section>
);
